module.exports = __webpack_public_path__ + "img/notification.72f2bd9d.svg";